module.exports = __webpack_public_path__ + "img/piel.52621214.webp";